import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import BalancoService from '../../../../../services/balanco-auth';
import { Link, useParams, Navigate } from 'react-router-dom';






const Balanco = () => {
    let { id } = useParams()

    const [fundo, setFundo] = useState("");
    const [tipo, setTipo] = useState("");
    const [ano, setAno] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);

    async function fetchBalanco(id) {
        const response = await BalancoService.balancoEdit(id);
        setFundo(response.data["fundo"]);
        setTipo(response.data["tipo"]);
        setAno(response.data["ano"]);
    }

    useEffect(() => {
        fetchBalanco(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const balanco = await BalancoService.editar(id, {
                fundo: fundo,
                tipo: tipo,
                ano: ano

            })
            if (balanco.data["cod_balanco"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col>
                            <Form.Group className="mb-3" controlId="fundo">
                                <FloatingLabel
                                    label="Fundo do Balanço"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="fundo"
                                        name="fundo"
                                        onChange={e => setFundo(e.target.value)}
                                    >
                                        <option value={fundo}>{fundo}</option>
                                        <option value="Consolidado">Consolidado</option>
                                        <option value="Fundo Municipal de Assistência Social">Fundo Municipal de Assistência Social</option>
                                        <option value="Fundo Municipal de Habitação">Fundo Municipal de Habitação</option>
                                        <option value="Fundo Municipal de Meio Ambiente">Fundo Municipal de Meio Ambiente</option>
                                        <option value="Fundo Municipal de Saúde">Fundo Municipal de Saúde</option>
                                        <option value="Fundo Municipal de Educação">Fundo Municipal de Educação</option>
                                        <option value="Fundo Municipal dos Direitos da Criança e dos Adolescentes">Fundo Municipal dos Direitos da Criança e dos Adolescentes</option>
                                        <option value="Prefeitura Municipal">Prefeitura Municipal</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="tipo">
                                <FloatingLabel
                                    label="Tipo do Balanço"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="tipo"
                                        name="tipo"
                                        onChange={e => setTipo(e.target.value)}
                                    >
                                        <option value={tipo}>{tipo}</option>
                                        <option value="Financeiro">Financeiro</option>
                                        <option value="Orçamentário">Orçamentário</option>
                                        <option value="Patrimonial">Patrimonial</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="Ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Ano"
                                        name="ano"
                                        onChange={e => setAno(e.target.value)}
                                    >
                                        <option value={ano}>{ano}</option>
                                        <option value="2025">2025</option>
                                        <option value="2024">2024</option>
                                        <option value="2023">2023</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                        <option value="2018">2018</option>
                                        <option value="2017">2017</option>                                        
                                        <option value="2026">2026</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Salvar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/balanco/listar'}>
                    <Button variant="danger" type="button">
                        Cancelar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Balanço editado com sucesso!</Alert>
                <Navigate to={'/restrito/balanco/listar'} />
            </Fragment>
        )
    }
}

export default Balanco;